module.exports = __webpack_public_path__ + "img/main-KV.24fd0203.png";